export const ACTION_TITTLES : {[field:string] : string} = {
  'delete':'Eliminar',
  'restore':'Restaurar/Recuperar',
  'edit':'Editar',
  'view':'Detalle',
  'assign':'Asignar',
  'custom':''
}
type actionType = 'link' | 'modal' | 'customFunction' | 'viewInModal';
export interface ActionInterface {
  traslation:string,
  icon:string,
  url?:string,
  type:actionType,
  showActionsButtons?:boolean,
  tittle?:string,
  templateName?:string
  modalSize?: 'small' | 'medium' | 'large';

}
export const ACTIONS_BASE : {[name:string]:ActionInterface}= {
  view : {
    traslation:'Detalle',
    icon:"visibility",
    url:'view',
    type:'link'
  },
  edit : {
    traslation:'Editar',
    icon:"edit",
    url:'edit',
    type:'link'
  },
  delete : {
    traslation:'Dar De Baja',
    icon:"delete",
    type:'modal'
  }
}
export const ACTIONS_DELETED_ELEM : {[name:string]:ActionInterface}= {
  view : {
    traslation:'Detalle',
    icon:"visibility",
    url:'view',
    type:'link'
  },
  restore : {
    traslation:'Restaurar',
    icon:"restore_from_trash",
    type:'modal'
  }
}
export const MOTIVOS_BAJA_BASE = [
  { value: 'Duplicado', label: 'Duplicado' },
  { value: 'Error de carga', label: 'Error de carga' },
  { value: 'Por solicitud', label: 'Por solicitud' },
  { value: 'Otro', label:  'Otro' }
];
